import { IMe } from "../../../../../redux/type";
import { AUTH_FIELDS } from "../../../../../redux/fields";

const convertProfileUtil = (props: any): IMe => {
	const data = props?.data || {};

	return {
		[AUTH_FIELDS.ID]: data[AUTH_FIELDS.ID] || 0,
		[AUTH_FIELDS.SURNAME]: data[AUTH_FIELDS.SURNAME] || "",
		[AUTH_FIELDS.DATE_REGISTRATION]: data[AUTH_FIELDS.DATE_REGISTRATION] || "",
		[AUTH_FIELDS.FIRSTNAME]: data[AUTH_FIELDS.FIRSTNAME] || "",
		[AUTH_FIELDS.PATRONYMIC]: data[AUTH_FIELDS.PATRONYMIC] || "",
		[AUTH_FIELDS.DATE_BIRTH]: data[AUTH_FIELDS.DATE_BIRTH] || "",
		[AUTH_FIELDS.EMAIL]: data[AUTH_FIELDS.EMAIL] || "",
		[AUTH_FIELDS.EMAIL_VERIFIED]: data[AUTH_FIELDS.EMAIL_VERIFIED] || false,
		[AUTH_FIELDS.ALLOW_MARKETING]: data[AUTH_FIELDS.ALLOW_MARKETING] || false,
		[AUTH_FIELDS.REF_CODE]: data[AUTH_FIELDS.REF_CODE] || null,
		[AUTH_FIELDS.COUNTRY]: data[AUTH_FIELDS.COUNTRY] || "",
		[AUTH_FIELDS.PHONE]: data[AUTH_FIELDS.PHONE] || null,
		[AUTH_FIELDS.SNILS]: data[AUTH_FIELDS.SNILS] || "",
		[AUTH_FIELDS.PASSPORT_SERIES]: data[AUTH_FIELDS.PASSPORT_SERIES] || "",
		[AUTH_FIELDS.PASSPORT_NUMBER]: data[AUTH_FIELDS.PASSPORT_NUMBER] || "",
		[AUTH_FIELDS.PASSPORT_ISSUED]: data[AUTH_FIELDS.PASSPORT_ISSUED] || "",
		[AUTH_FIELDS.PASSPORT_DATE_ISSUE]:
			data[AUTH_FIELDS.PASSPORT_DATE_ISSUE] || "",
		[AUTH_FIELDS.INDEX]: data[AUTH_FIELDS.INDEX] || "",
		[AUTH_FIELDS.LOCALITY]: data[AUTH_FIELDS.LOCALITY] || "",
		[AUTH_FIELDS.STREET]: data[AUTH_FIELDS.STREET] || "",
		[AUTH_FIELDS.NUMBER_HOUSE]: data[AUTH_FIELDS.NUMBER_HOUSE] || "",
		[AUTH_FIELDS.APARTMENT]: data[AUTH_FIELDS.APARTMENT] || "",
		[AUTH_FIELDS.DIPLOMA]: {
			id: data[AUTH_FIELDS.DIPLOMA]?.id || 0,
			nameInstitution: data[AUTH_FIELDS.DIPLOMA]?.nameInstitution || null,
			diplomNumber: data[AUTH_FIELDS.DIPLOMA]?.diplomNumber || null,
			diplomSerial: data[AUTH_FIELDS.DIPLOMA]?.diplomSerial || null,
			issueDate: data[AUTH_FIELDS.DIPLOMA]?.issueDate || null,
			academicDegree: data[AUTH_FIELDS.DIPLOMA]?.academicDegree || null,
			surnameByDiplom: data[AUTH_FIELDS.DIPLOMA]?.surnameByDiplom || null,
			diplomChecked: data[AUTH_FIELDS.DIPLOMA]?.diplomChecked || false,
			dateVerification: data[AUTH_FIELDS.DIPLOMA]?.dateVerification || "",
			speciality: data[AUTH_FIELDS.DIPLOMA]?.speciality || null,
			specialization: data[AUTH_FIELDS.DIPLOMA]?.specialization || null,
			locality: data[AUTH_FIELDS.DIPLOMA]?.locality || null,
		},
		[AUTH_FIELDS.ROLES]: data[AUTH_FIELDS.ROLES] || [],
		[AUTH_FIELDS.SOCIAL_NETWORK]: {
			VK: data[AUTH_FIELDS.SOCIAL_NETWORK]?.VK || "",
			Facebook: data[AUTH_FIELDS.SOCIAL_NETWORK]?.Facebook || "",
			Instagram: data[AUTH_FIELDS.SOCIAL_NETWORK]?.Instagram || "",
		},
		[AUTH_FIELDS.MESSENGERS]: {
			WhatsApp: data[AUTH_FIELDS.MESSENGERS]?.WhatsApp || null,
			Telegram: data[AUTH_FIELDS.MESSENGERS]?.Telegram || null,
		},
		[AUTH_FIELDS.REGIONS]: data[AUTH_FIELDS.REGIONS] || [],
		[AUTH_FIELDS.WORK_PLACES]:
			data[AUTH_FIELDS.WORK_PLACES]?.map((place: any) => ({
				id: place.id || 0,
				name: place.name || null,
				locality: place.locality || null,
				street: place.street || null,
				house: place.house || null,
				website: place.website || null,
				workEmail: place.workEmail || "",
				workPhone: place.workPhone || "",
			})) || [],
		[AUTH_FIELDS.PURCHASED_PROGRAMS]:
			data[AUTH_FIELDS.PURCHASED_PROGRAMS] || [],
		[AUTH_FIELDS.STATUS]: data[AUTH_FIELDS.STATUS] || 0,
		[AUTH_FIELDS.EMAIL_ADMIN_PANEL]: data[AUTH_FIELDS.EMAIL_ADMIN_PANEL] || "",
		[AUTH_FIELDS.DESCRIPTION]: data[AUTH_FIELDS.DESCRIPTION] || null,
		[AUTH_FIELDS.CITY]: data[AUTH_FIELDS.CITY] || null,
		[AUTH_FIELDS.PROF_INTERESTS]: data[AUTH_FIELDS.PROF_INTERESTS] || [],
		[AUTH_FIELDS.IS_PARTICIPATED_EVENT]:
			data[AUTH_FIELDS.IS_PARTICIPATED_EVENT] || null,
		[AUTH_FIELDS.AVAILABLE_IN_SEARCH]:
			data[AUTH_FIELDS.AVAILABLE_IN_SEARCH] || false,
		[AUTH_FIELDS.CREATED_AT]: data[AUTH_FIELDS.CREATED_AT] || "",
		[AUTH_FIELDS.NEAREST_REPRESENTATIVE]: {
			id: data[AUTH_FIELDS.NEAREST_REPRESENTATIVE]?.id || 0,
			header: data[AUTH_FIELDS.NEAREST_REPRESENTATIVE]?.header || "",
		},
		[AUTH_FIELDS.PHOTO]: data[AUTH_FIELDS.PHOTO] || null,
		[AUTH_FIELDS.COUNTRY_CODE]: data[AUTH_FIELDS.COUNTRY_CODE] || "",
		[AUTH_FIELDS.IS_STUDENT]: data[AUTH_FIELDS.IS_STUDENT] || false,
		[AUTH_FIELDS.STUDENT_CARD]: {
			id: data[AUTH_FIELDS.STUDENT_CARD]?.id || 0,
			institute: data[AUTH_FIELDS.STUDENT_CARD]?.institute || null,
			city: data[AUTH_FIELDS.STUDENT_CARD]?.city || null,
			speciality: data[AUTH_FIELDS.STUDENT_CARD]?.speciality || null,
			specialization: data[AUTH_FIELDS.STUDENT_CARD]?.specialization || null,
			issueDate: data[AUTH_FIELDS.STUDENT_CARD]?.issueDate || null,
			number: data[AUTH_FIELDS.STUDENT_CARD]?.number || null,
			locality: data[AUTH_FIELDS.STUDENT_CARD]?.locality || null,
		},
		[AUTH_FIELDS.NATIONALITY]: data[AUTH_FIELDS.NATIONALITY] || "",
		[AUTH_FIELDS.PROGRAMS]: data[AUTH_FIELDS.PROGRAMS] || [],
		[AUTH_FIELDS.STATUS_NAME]: data[AUTH_FIELDS.STATUS_NAME] || "",
		[AUTH_FIELDS.IS_MEMBER_ASSOCIATION]:
			data[AUTH_FIELDS.IS_MEMBER_ASSOCIATION] || false,
		[AUTH_FIELDS.DAY_END_ASSOCIATION]:
			data[AUTH_FIELDS.DAY_END_ASSOCIATION] || 0,
		[AUTH_FIELDS.DATE_END_ASSOCIATION]:
			data[AUTH_FIELDS.DATE_END_ASSOCIATION] || "",
		[AUTH_FIELDS.IS_HAVE_FULL_REGISTRATION]:
			data[AUTH_FIELDS.IS_HAVE_FULL_REGISTRATION] || false,
		[AUTH_FIELDS.IS_OPEN_WINDOW_CONFIRM]:
			data[AUTH_FIELDS.IS_OPEN_WINDOW_CONFIRM] || false,
		[AUTH_FIELDS.DIPLOMA_FILES]: data[AUTH_FIELDS.DIPLOMA_FILES] || [],
		[AUTH_FIELDS.CHANGE_SURNAME_FILES]:
			data[AUTH_FIELDS.CHANGE_SURNAME_FILES] || [],
		[AUTH_FIELDS.STUDENT_CARDS]: data[AUTH_FIELDS.STUDENT_CARDS] || [],
		[AUTH_FIELDS.LEARNING_CERTIFICATES]:
			data[AUTH_FIELDS.LEARNING_CERTIFICATES] || [],
	};
};

export default convertProfileUtil;
